import { ISnackbarError } from './types';
import { Dispatch } from '../../../../../types/actions';
import { SnackbarVariant } from '../../store/types';
import { SNACKBAR_BUTTON_CLOSE } from '../constants';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';
import { addUpdateSnackbarWithBubble } from '../addUpdateSnackbarWithBubble/addUpdateSnackbarWithBubble';

export const snackbarErrorDefault = (
    options: ISnackbarError
) => {
    return (dispatch: Dispatch) => {
        const shouldUseControlsDefault = options.buttons === undefined;
        if (shouldUseControlsDefault) {
            options.buttons = [{
                onClick: () => dispatch(getDefaultActionEvent(options.id)),
                text: SNACKBAR_BUTTON_CLOSE
            }];
        }
        dispatch(addUpdateSnackbarWithBubble({
            ...options,
            title: null,
            icon: 'error',
            variant: SnackbarVariant.ERROR,
        }));
    }
};
